// Disabling the following jsdoc ESLint rules only because this code is checked by TypeScript directly
/* eslint-disable jsdoc/check-types */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/require-param-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useId, useState } from 'react';
import {
  Formik, Form, Field, ErrorMessage,
} from 'formik';
import { OtpInput } from 'components/OtpInput';
import { required } from '../Form/validators';
import styles from './styles.module.scss';

/**
 * @param {{ oneTimeCode: string; }} values
 */
function validate(values) {
  const errors = {};

  const oneTimeCodeValidators = [required('Please enter a valid password')];
  const oneTimeCodeError = oneTimeCodeValidators
    .map((validator) => validator(values.oneTimeCode))
    .find((error) => Boolean(error));

  if (oneTimeCodeError) {
    errors.oneTimeCode = oneTimeCodeError;
  }

  return errors;
}

/**
 * @typedef {Object} VerifyCodeFormProps
 * @property {string} email - The email address to which the one-time code was sent
 * @property {() => void} onSuccess - Callback function to call on successful verification
 */

/**
 * Signup form component
 * @param {VerifyCodeFormProps} props
 */
export function VerifyCodeForm({ email, onSuccess }) {
  const idPrefix = useId();
  /**
   * @param {string} s
   */
  const id = (s) => `${idPrefix}-${s}`;
  const [submissionError, setSubmissionError] = useState('');

  return (
    <div className={styles.verifyCodeForm}>
      <h1>Confirm Code</h1>
      <p className={styles.instructions}>{`Enter the one-time code we sent to ${email}`}</p>
      <p className={styles.instructions}>
        If you can’t find our email, please check your spam folder
      </p>

      <Formik
        initialValues={{ oneTimeCode: '' }}
        validate={validate}
        validateOnMount
        onSubmit={(values, { setSubmitting }) => {
          fetch('/auth/users/otp/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, brand: 'news', one_time_code: values.oneTimeCode }),
          })
            .then((response) => response.json())
            .then((json) => {
              if (json?.error) {
                if (json.error.code === 'AUTH_1037') {
                  throw new Error(
                    'The code you entered is invalid or has expired. Please try again.',
                  );
                }
                throw new Error(json.error.user_message);
              }
            })
            .then(() => onSuccess())
            .catch((err) => setSubmissionError(err.message || 'Submission failed. Please try again.'))
            .finally(() => setSubmitting(false));
        }}
      >
        {({ isSubmitting, isValid }) => (
          <Form>
            {submissionError && <div>{submissionError}</div>}

            <div className={styles.validationError} id={id('otpCode-error')}>
              <ErrorMessage name="oneTimeCode" />
            </div>
            <Field
              id={id('oneTimeCode')}
              name="oneTimeCode"
              type="text"
              required
              aria-describedby={id('oneTimeCode-error')}
              aria-label="One-time code"
              autoFocus
              as={OtpInput}
            />

            <button type="submit" disabled={isSubmitting || !isValid}>
              Continue
            </button>

            <button
              type="button"
              onClick={() => {
                fetch('/auth/users/otp/request', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ email, brand: 'news' }),
                });
              }}
            >
              Resend Code
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
